import { render, staticRenderFns } from "./AscAlertList.vue?vue&type=template&id=5a3a9939&"
import script from "./AscAlertList.vue?vue&type=script&lang=js&"
export * from "./AscAlertList.vue?vue&type=script&lang=js&"
import style0 from "./AscAlertList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports